<template>
  <div class="content rewards">
    <div class="container-fluid">
      <card>
        <template slot="header">
          <div class="row">
            <div class="col">
              <header-navigator :routes="routesData.data"></header-navigator>
            </div>
            <div class="col">
              <button type="button" class="btn-plyo-small" style="float:right" @click="onAddRewardClicked">
                + ADD REWARD
              </button>
            </div>
          </div>
        </template>
        <template>
          <div class="reward" v-for="item in rewards" :key="item.lasted_edited">
            <div class="reward-title">
              <router-link to="/reward/edit" @click.native="setRewardBeingEdited(item)">{{item.point_value}} Points | {{item.title}}</router-link>
              <p>Last edited on {{item.last_edited}}</p>
            </div>
            <div class="row reward-details">
              <div class="col status">
                <div class="active" v-if="item.live">ON</div>
                <div class="inactive" v-else>OFF</div>
              </div>
              <div class="col options">
                <overlay-dropdown title="Options" :options="getOptions(item)" @onOptionSelected="onOptionSelected($event, item)"></overlay-dropdown>
              </div>
            </div>
          </div>
        </template>
      </card>
      <div class="row">
        <div class="col archived-link">
          <router-link to="/rewards/archived">View Archived Rewards ></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import HeaderNavigator from '@/components/UIComponents/HeaderNavigator.vue'

  export default {
    components: {
      Card,
      HeaderNavigator,
    },
    data () {
      return {
        routesData: {
          data: [
            {title: 'Manage Rewards', route: '/rewards'},
          ]
        }
      }
    },
    methods: {
      getOptions(reward) {
        if (reward.live) {
          return ["Edit Reward", "Copy To New", "Turn Off", "Archive"]
        } else {
          return ["Edit Reward", "Copy To New", "Turn On", "Archive"]
        }
      },
      onOptionSelected(option, reward) {
        if (option === "Edit Reward") {
          this.setRewardBeingEdited(reward)
          this.goToEditReward()
        } else if (option === "Copy To New") {
          this.setRewardBeingEdited(reward)
          this.goToAddReward()
        } else if (option === "Turn Off") {
          const payload = {
            status: false,
            merchant_id: this.$store.getters.advertiser.id,
            reward_id: reward.id,
          }
          this.$store.dispatch('uploadRewardLiveStatusUpdate', payload)
        } else if (option === "Turn On") {
          const payload = {
            status: true,
            merchant_id: this.$store.getters.advertiser.id,
            reward_id: reward.id,
          }
          this.$store.dispatch('uploadRewardLiveStatusUpdate', payload)
        } else if (option === "Archive") {
          if (reward.live) {
            const payload = {
              status: false,
              merchant_id: this.$store.getters.advertiser.id,
              reward_id: reward.id,
            }
            this.$store.dispatch('uploadRewardLiveStatusUpdate', payload)
          }

          const payload = {
            is_archived: true,
            merchant_id: this.$store.getters.advertiser.id,
            reward_id: reward.id,
          }
          this.$store.dispatch('uploadRewardArchivedStatus', payload);
        }
      },
      setRewardBeingEdited (reward) {
        this.$store.dispatch('setRewardBeingEdited', reward)
      },
      onAddRewardClicked () {
        this.setRewardBeingEdited(null)
        this.goToAddReward()
      },
      goToAddReward () {
        this.$router.push('/reward/new')
      },
      goToEditReward() {
        this.$router.push('/reward/edit')
      },
      compareRewards(a, b) {
        if (a.live & !b.live) {
          return -1;
        } else if (b.live & !a.live) {
          return 1;
        } else if (b.point_value > a.point_value) {
          return -1;
        } else if (a.point_value > b.point_value) {
          return 1;
        }

        return 0;
      }
    },
    computed: {
      rewards() {
        return this.$store.getters.unArchivedRewards.sort(this.compareRewards)
      },
    }, 
    mounted () {
      this.$nextTick(() => {
        this.$emit('scrollTop', 0)
      });
    }
  }
</script>
<style>

</style>